import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/home-page/components/HomePageInteractive.tsx");
